import {createAsyncThunk} from "@reduxjs/toolkit";
import apiInstanceV2 from "../../Apis/AxiosV2";

export const GetAllUserFiles = createAsyncThunk(
    'userFileSection/getAllUserFiles',
    async (userId, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .get(`user-service/user-file/get-all/by-user-id/${userId}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);
